import React from 'react';
import './header.component.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as FontIcon from '@fortawesome/free-solid-svg-icons';

class HeaderComponent extends React.Component {
    constructor(props: any) {
        super(props);
        this.onClickLogout = this.onClickLogout.bind(this);
    }

    onClickLogout(e: any) {
        localStorage.clear();
    }

    render() {
        return (
            <div className="m-main__header-component">
                <section className="header">
                    <div className="navigation">
                        <a className="button" onClick={this.onClickLogout} href="/">
                            <FontAwesomeIcon icon={FontIcon.faSignOutAlt} />
                            <div className="logout">LOGOUT</div>
                        </a>
                    </div>
                </section>
            </div>
        );
    }
}

export default HeaderComponent;
